<template>
  <div class="section-abstract-header">Coordonnées bancaires et règlements</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionPrelevMeansExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Prélèvement à la source</div>
        <div v-if="etablissement.prelevRibId > 0" class="section-abstract-display">Moyen de paiement ({{ getPrelevementMeans() }})</div>
        <div v-else class="section-abstract-display">Ajouter un compte bancaire</div>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalaireMeansExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Paiements des salaires et des frais</div>
        <div v-if="etablissement.salaireMeansId > 0" class="section-abstract-display">Moyen de paiement ({{ getSalaireMeans() }})</div>
        <div v-else class="section-abstract-display">Ajouter un compte bancaire</div>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import SectionEtablissementPaymentAbstract from "@/generated/sections/SectionEtablissementPaymentAbstract.vue";
import {storePaymentMeans, storeRib} from "@/generated/stores";

export default defineComponent({
  components: {},
  extends: SectionEtablissementPaymentAbstract,
  methods: {
    getPrelevementMeans(): string {
      const rib = storeRib.getRib(this.etablissement.prelevRibId);
      if (rib) {
        return rib.display;
      } else {
        return "";
      }
    },
    getSalaireMeans(): string {
      const res = storePaymentMeans.getPaymentMeans(this.etablissement.salaireMeansId);
      if (res) {
        return res.label;
      } else {
        return "";
      }
    }
  }
})
</script>
